import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
const Component = props => {
  return _jsx(_Fragment, {
    children: _jsxs("svg", Object.assign({
      viewBox: "0 0 30 30",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props, {
      children: [_jsx("mask", {
        id: "oat4vsxsg__mask0_15244_118054",
        style: {
          maskType: "alpha"
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "30",
        height: "30",
        children: _jsx("path", {
          d: "M0.5 15C0.5 6.99187 6.99187 0.5 15 0.5C23.0081 0.5 29.5 6.99187 29.5 15C29.5 23.0081 23.0081 29.5 15 29.5C6.99187 29.5 0.5 23.0081 0.5 15Z",
          fill: "#C4C4C4",
          stroke: "#152361"
        })
      }), _jsxs("g", {
        mask: "url(#oat4vsxsg__mask0_15244_118054)",
        children: [_jsx("path", {
          d: "M30 0H0V30H30V0Z",
          fill: "white"
        }), _jsx("path", {
          d: "M30 10H0V30H30V10Z",
          fill: "#00966E"
        }), _jsx("path", {
          d: "M30 20H0V30H30V20Z",
          fill: "#D62612"
        }), _jsx("path", {
          d: "M1 15C1 7.26801 7.26801 1 15 1C22.732 1 29 7.26801 29 15C29 22.732 22.732 29 15 29C7.26801 29 1 22.732 1 15Z",
          stroke: "#152361",
          strokeWidth: "2"
        })]
      })]
    }))
  });
};
export default Component;
